export const REFEREE_MODEL = "referee";

const refereeModel = {
  firstName: "",
  lastName: "",
  emailAddress: "",
  phoneNumber: "",
  jobTitle: "",
  company: "",
  reference: {
    jsonApi: "hasOne",
    type: "references"
  }
};

export default refereeModel;
